module.exports = __webpack_public_path__ + "img/64.2a4bf368.jpg";